import { EActionTypes } from './actionTypes';
import { TRoomsFiltersActiveIDs, TStatusFiltersActiveIDs } from '../types';

export const setRoomsFilter = (payload: TRoomsFiltersActiveIDs | null) => ({
  type: EActionTypes.setRoomsFilter,
  payload,
});

export const setStatusFilter = (payload: TStatusFiltersActiveIDs | null) => ({
  type: EActionTypes.setStatusFilter,
  payload,
});
